<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Account Authorization History</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    @if (authorizationList != undefined && authorizationList.length > 0) {
      <table class="table table-bordered table-custom">
        <thead>
          <tr>
            <th>Requested</th>
            <th>Reason</th>
            <th>Process Remark</th>
            <th>Status</th>
            <th>Granted Due Date</th>
          </tr>
        </thead>
        <tbody>
          @for (auth of authorizationList; track auth; let i = $index) {
            <tr>
              <td [ngClass]="{ latestRecord: i == 0 }">{{ auth.CreatedAt | date: "dd-MM-yyyy" }} | {{ auth.CreatedBy }}</td>
              <td [ngClass]="{ latestRecord: i == 0 }">{{ auth.Remark }}</td>
              <td [ngClass]="{ latestRecord: i == 0 }">{{ auth.GrantedRemark || auth.RevokedRemark }}</td>
              <td [ngClass]="{ latestRecord: i == 0 }">
                @if (auth.GrantedBy != undefined && auth.RevokedBy == undefined) {
                  <span class="badge text-bg-success">Granted by {{ auth.GrantedBy }} </span>
                }
                @if (auth.RevokedBy != undefined) {
                  <span class="badge text-bg-danger">Revoked by {{ auth.RevokedBy }} on {{ auth.RevokedOn | date: "dd-MM-yyyy" }}</span>
                }
              </td>
              <td [ngClass]="{ latestRecord: i == 0 }">
                @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
                  <button class="btn btn-dark" (click)="confirmBeforeAction(auth)">Process</button>
                }
                @if (auth.GrantedUntil != undefined) {
                  {{ auth.GrantedUntil | date: "dd-MM-yyyy" }}
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p>Do not have any authorization record for this account</p>
    }
  </div>
</form>
